import { render, staticRenderFns } from "./EmployeeResponsibilities.vue?vue&type=template&id=50d8dc8a&scoped=true"
import script from "./EmployeeResponsibilities.vue?vue&type=script&lang=js"
export * from "./EmployeeResponsibilities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d8dc8a",
  null
  
)

export default component.exports